import type { WithFields, WithIncludes } from "@/api/jsonapi";
import type { Session as _Session } from "@/api/raptor";
import type { GetOneParams } from "@mb-pro-ui/utils";
import { isHttpError, useGetOne } from "@mb-pro-ui/utils";

const fields = {
  sessions: ["start-ts", "unit"],
  units: ["name"],
} as const;

const include = { unit: {} } as const;

export type Session = WithIncludes<
  WithFields<_Session, typeof fields>,
  typeof include
>;

export default function useSession(
  opts?: Omit<GetOneParams<Session, Session>, "include" | "fields">,
) {
  return useGetOne<Session>("raptor/sessions", "current", {
    ...opts,
    include,
    fields,
    retry: (_, error) =>
      !isHttpError(error) || ![401, 403, 404].includes(error.status),
    retryDelay: (_, error) => (isHttpError(error) ? 1500 : 5000),
  });
}
